import type { MutationConfig } from "apps/visits/core/lib/react-query";
import { useMutation } from "react-query";
import { useGetSlug } from "../store/use-config";
import { GroupActionsOrderingRepository } from "./group-actions-ordering.api";

const groupActionsOrderingRepository = new GroupActionsOrderingRepository();

type UseResendVerificationCodeOptions = {
  config?: MutationConfig<typeof groupActionsOrderingRepository.resendVerificationCode>;
};

export const useResendVerificationCode = ({ config }: UseResendVerificationCodeOptions) => {
  const slug = useGetSlug();

  return useMutation({
    ...config,
    mutationFn: (data) => groupActionsOrderingRepository.resendVerificationCode(data, slug),
  });
};
